import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  includesAiAlertEventWindowSelector,
  selectedAiAlertSelector,
} from '@store/trends/aiAlerts/selectors';
import { INVERTED_METRIC_SWITCH_MAP } from '@utils/metrics';
import {
  getAlertsOption,
  legendSeries,
  resetAlertOption,
} from './aiAlertUtils';
import { DEVICE_AXIS, PCP_AXIS } from './constants';

// TODO: cleanup after depricating old trends diag alerts

// modifies input series
export function formatAlertSeries(option, alert, includesAlertWindow) {
  const { xAxis, yAxis, series } = option;

  const plotAlertSeries = !isEmpty(alert) && includesAlertWindow;
  const { aiAlertKey } = alert;
  const isPcpAlert = aiAlertKey === 'AUTOALERTPCP' || aiAlertKey === 'APP_ACTIVE_DEVICES';

  const alertSeries = plotAlertSeries
    ? getAlertsOption({ alert, xAxis, yAxis })
    : resetAlertOption(series);

  // TODO: is anomaly label required?
  // mark main metric series as anomaly
  // const metricSeries = { id: METRIC_SERIES , name: plotAlertSeries ? 'Anomaly' : 'Primary' };

  // an axis is only rendered if there's a series tied to it
  return {
    yAxis: [
      { id: PCP_AXIS, show: plotAlertSeries && isPcpAlert },
      { id: DEVICE_AXIS, show: plotAlertSeries && !isPcpAlert },
    ],
    series: [...alertSeries],
  };
}

function useAIAlertSeries({ instance, metric, enabled = false, additionalTriggerDeps = [] }: any) {
  const alert = useSelector(selectedAiAlertSelector);
  const includesAlertWindow = useSelector(includesAiAlertEventWindowSelector);
  const isEnabled = enabled && !isEmpty(alert);

  useEffect(() => {
    if (instance && isEnabled) {
      const { pulse5MetricKey } = alert;
      const alertMetric =
        pulse5MetricKey in INVERTED_METRIC_SWITCH_MAP
          ? INVERTED_METRIC_SWITCH_MAP[pulse5MetricKey]
          : pulse5MetricKey;

      if (metric === alertMetric) {
        // replace merge workflow resolved the race issues
        // TODO: remove timeout post additional testing
        setTimeout(() => {
          const option = instance.getOption();
          if (option) {
            const { yAxis, series } = formatAlertSeries(option, alert, includesAlertWindow);
            instance.setOption({ series, yAxis });
          }
        }, 100);
      } else if (metric === pulse5MetricKey) {
        // unit toggle applied, reset alerts
        setTimeout(() => {
          const option = instance.getOption();
          if (option) {
            const { yAxis, series } = formatAlertSeries(option, {}, includesAlertWindow);
            instance.setOption({ series, yAxis });
          }
        }, 100);
      }
    }
  }, [
    instance,
    metric,
    isEnabled,
    JSON.stringify(alert),
    includesAlertWindow,
    ...additionalTriggerDeps,
  ]);

  return { legendSeries };
}

export default useAIAlertSeries;
